"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Spinner = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Spinner"));
var styles = {
  "loading": "loading_3fKetC",
  "small": "small_RdLdVC",
  "medium": "medium_1J8VYf",
  "spinner": "spinner_Hy2s0q"
}; 
require('./LoadingElement.css');
var LoadingElement = function LoadingElement(_ref) {
  var message = _ref.message,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'loading-element' : _ref$testId,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles[size], styles.loading)
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    testId: testId,
    size: "s",
    className: styles.spinner
  }), /*#__PURE__*/_react.default.createElement("span", null, message || 'Loading more'));
};
var _default = exports.default = LoadingElement;
//# sourceMappingURL=LoadingElement.js.map